/** Opciones de evaluación POS: código promo y promos elegidas por cajero. */
export type CartEvaluationOptions = {
  /** @deprecated Preferir promoCodes; se mantiene por compat. */
  promoCode?: string | null;
  /** Uno o más códigos manuales (stackable según cada promo). */
  promoCodes?: string[] | null;
  selectedPromotionIds?: string[];
  /** Conteo de usos por promotionId (para validar usageLimit). Map o Record plano. */
  usageCountByPromotionId?: Map<string, number> | Record<string, number>;
  /**
   * Offset de timezone en minutos para evaluar scheduleWindow y weekdays
   * en hora local del negocio. Ej. -180 para Argentina (UTC-3).
   * Sin este valor, se usa el timezone del runtime (POS app = local, edge = UTC).
   */
  timezoneOffsetMinutes?: number;
};

export function normalizePromoCode(code: string | null | undefined): string | null {
  if (code == null) return null;
  const trimmed = code.trim();
  return trimmed ? trimmed.toUpperCase() : null;
}

/** Lee usage count desde Map o Record (VUELTO-EDGE-1: plain object no tiene `.get`). */
export function usageCountForPromotion(
  usageCounts: Map<string, number> | Record<string, number> | undefined,
  promotionId: string,
): number | undefined {
  if (!usageCounts) return undefined;
  if (usageCounts instanceof Map) {
    return usageCounts.get(promotionId);
  }
  const value = usageCounts[promotionId];
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined;
}

export function resolveManualPromoCodes(options?: CartEvaluationOptions | null): string[] {
  if (!options) return [];
  const codes = new Set<string>();
  const single = normalizePromoCode(options.promoCode);
  if (single) codes.add(single);
  for (const raw of options.promoCodes ?? []) {
    const normalized = normalizePromoCode(raw);
    if (normalized) codes.add(normalized);
  }
  return [...codes];
}
